__turbopack_context__.v({
  "text": "QJnTUa_text",
});
